import { render, staticRenderFns } from "./ChatListItem.vue?vue&type=template&id=a125066e&scoped=true&"
import script from "./ChatListItem.vue?vue&type=script&lang=js&"
export * from "./ChatListItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatListItem.vue?vue&type=style&index=0&id=a125066e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a125066e",
  null
  
)

export default component.exports